import {useConfig} from '@aboutyou/config';
import {DataFetcher, PriorityConfig} from '@aboutyou/data-fetcher';
import {useIsFeatureActive} from '@aboutyou/feature-flags';
import {lazy} from '@aboutyou/lazy-imports';
import React from 'react';
import {useDiscountsRequest} from '../hooks/useDiscounts';
import {
  DiscountBannerView,
  DiscountBannerViewProps,
} from './DiscountBannerView';

export const DiscountBanner: React.FC<
  PriorityConfig & DiscountBannerViewProps & {showHeroNotification?: boolean}
> = ({renderingPriority, showHeroNotification, ...viewProps}) => {
  const discounts = useDiscountsRequest();
  const {isActive: isBasHugoTakeoverActive} = useIsFeatureActive(
    'bas_homepage_campaign_hugo',
  );
  const {device} = useConfig();

  if (
    discounts.data?.discount ||
    (isBasHugoTakeoverActive && device === 'desktop')
  ) {
    return (
      <DataFetcher
        request={discounts}
        Error={null}
        renderingPriority={renderingPriority}
        View={DiscountBannerView}
        viewProps={viewProps}
      />
    );
  }

  return (
    <HeroNotificationInDiscountBanner
      showHeroNotification={showHeroNotification}
      reducedSize={viewProps.reducedSize}
      onClick={viewProps.onClick}
    />
  );
};

const HeroNotificationInDiscountBanner = lazy(() =>
  import('./HeroNotificationInDiscountBanner').then(module => ({
    default: module.HeroNotificationInDiscountBanner,
  })),
);
